import { get, post, put } from "../helpers/admin_api_helper"
import { get as getUser } from "../helpers/user_api_helper"

export const getCompany = () => get(`/company/get`)
export const createCompany = (data: {}) => post(`/company`, data)
export const updateCompany = (data: any) => put(`/company/${data.ID}`, data)

export const getUserCompany = () => getUser(`/company/get`)

export const getEmailConfig = () => get(`/company/email-config`)
export const sendTestEmail = (data: { to: string }) => post(`/company/test-email`, data)
